import { render, staticRenderFns } from "./TheResetPassword.vue?vue&type=template&id=0763a2a5&"
import script from "./TheResetPassword.vue?vue&type=script&lang=js&"
export * from "./TheResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports